import { Flex, Typography } from "antd";
import { TableConfig } from "../../../../docstore-section-table/model";

interface DataType {
  key: string;
  docName: {
    name: string;
    description: string;
  };
  code: string;
  issuer: string;
}

export const tableConfig: TableConfig = {
  columns: [
    {
      title: "Документ",
      dataIndex: "docName",
      key: "docName",
      render: (value) => (
        <Flex gap="2px" vertical>
          <Typography.Text>{value?.name}</Typography.Text>
          <Typography.Text>{value?.description}</Typography.Text>
        </Flex>
      ),
    },
    {
      title: "Шифр",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Дата выдачи",
      dataIndex: "issuer",
      key: "issuer",
    },
  ],
};

export const mockData: DataType[] = [
  {
    key: "1",
    docName: {
      name: "Рабочая документация",
      description: "Рабочая документация",
    },
    code: "46/УК/ДОУ/21/156-РД-ЭН",
    issuer: "27.02.2025",
  },
  {
    key: "2",
    docName: {
      name: "План этажа",
      description: "Описание плана этажа",
    },
    code: "ПЗ-002",
    issuer: "2024-01-20",
  },
];
